export default __webpack_public_path__ + "static/banner-image-aa67eec66ede2a5fea78c427053aec41.png";